var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcVisa = function SvgIcVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 43 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic_visa_svg__a)",
    d: "M22.174 4.476c-.024 1.95 1.719 3.038 3.032 3.685 1.35.664 1.802 1.09 1.797 1.684-.01.908-1.076 1.31-2.074 1.325-1.74.027-2.753-.475-3.557-.855l-.627 2.966c.807.377 2.302.705 3.852.719 3.638 0 6.019-1.816 6.032-4.632.014-3.574-4.889-3.771-4.855-5.369.011-.484.468-1.001 1.47-1.132.496-.067 1.864-.118 3.416.605l.609-2.87A9.2 9.2 0 0 0 28.027 0c-3.425 0-5.834 1.84-5.853 4.476M37.12.247a1.58 1.58 0 0 0-1.474.993l-5.198 12.55h3.636l.724-2.023h4.443l.42 2.022h3.204L40.079.247zm.509 3.658 1.049 5.086h-2.874zM17.766.247 14.9 13.79h3.464L21.23.247zm-5.126 0L9.034 9.464 7.575 1.627C7.405.752 6.728.247 5.978.247H.083L0 .64c1.21.266 2.585.694 3.418 1.153.51.28.655.524.823 1.19l2.763 10.806h3.661L16.278.247z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic_visa_svg__a",
    x1: 19.711,
    x2: 20.121,
    y1: 14.281,
    y2: -0.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })))));
};
export default SvgIcVisa;